module.exports = __webpack_public_path__ + "img/img_mframe05.641e2f37.png";